<div class="add-to-calendar">
    <ul *ngIf="isOpen" class="calendar-dropdown"  [ngClass]="multi ? 'multievent' :'' ">
        <li>
            <a [href]="addToGoogleCalendar" target="_blank" (click)="closeDropdown()">
                Google
            </a>
        </li>

        <li>
            <a [href]="addToYahooCalendar" target="_blank" (click)="closeDropdown()">
                Yahoo
            </a>
        </li>

        <li>
            <button class="dropdown-btn" (click)="downloadICS()">
                Apple
            </button>
        </li>

        <li>
            <button class="dropdown-btn" (click)="downloadICS()">
                Outlook
            </button>
        </li>

        <li>
            <button class="dropdown-btn" (click)="addToOutlookWeb()">
                Outlook Web
            </button>

        </li>

    </ul>
</div>